import React from 'react';
import './footer-header.css'

const Footerheader = (props) => {
    return ( 
        <h1 className='footerheader'>{props.title}</h1>
     );
}
 
export default Footerheader;